module.exports = __webpack_public_path__ + "img/DE00558.887d50d5.png";